import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "task-reminders-backdrop"
}
const _hoisted_2 = { class: "task-reminders-head" }
const _hoisted_3 = { id: "task-reminders-title" }
const _hoisted_4 = { class: "task-reminders-list" }
const _hoisted_5 = { class: "task-reminder-name" }
const _hoisted_6 = { class: "task-reminder-meta" }
const _hoisted_7 = {
  key: 0,
  class: "task-reminder-decline"
}
const _hoisted_8 = { class: "task-reminder-btns" }
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = {
  key: 1,
  class: "task-reminder-btns"
}
const _hoisted_11 = ["disabled", "onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.reminders.length)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        (!_ctx.minimised)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "task-reminders",
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "task-reminders-title",
                onKeydown: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.minimise()), ["esc"]))
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.reminders.length == 1 ? 'A task was sent to you' : _ctx.reminders.length + ' tasks were sent to you'), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "task-reminders-min",
                    ref: "minButton",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.minimise()))
                  }, "Minimise", 512)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reminders, (r) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: r.ID,
                      class: "task-reminder"
                    }, [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(r.Name), 1),
                      _createElementVNode("div", _hoisted_6, " From " + _toDisplayString(r.SentByName || 'a teammate') + " · " + _toDisplayString(r.MeetingName) + " · on " + _toDisplayString(r.BoardName) + " (" + _toDisplayString(r.Column) + ") ", 1),
                      (_ctx.decliningID == r.ID)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _withDirectives(_createElementVNode("textarea", {
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.declineReason) = $event)),
                              maxlength: "500",
                              rows: "2",
                              placeholder: "Why not? (optional - they'll see this)",
                              "aria-label": "Reason for not doing this"
                            }, null, 512), [
                              [_vModelText, _ctx.declineReason]
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn",
                                disabled: _ctx.busyID == r.ID,
                                onClick: ($event: any) => (_ctx.decline(r))
                              }, "Not doing this", 8, _hoisted_9),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn-invert",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.decliningID = null))
                              }, "Back")
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn",
                              disabled: _ctx.busyID == r.ID,
                              onClick: ($event: any) => (_ctx.done(r))
                            }, "Done", 8, _hoisted_11),
                            _createElementVNode("button", {
                              type: "button",
                              class: "btn-invert",
                              onClick: ($event: any) => (_ctx.open(r))
                            }, "Open", 8, _hoisted_12),
                            _createElementVNode("button", {
                              type: "button",
                              class: "task-reminder-link",
                              onClick: ($event: any) => (_ctx.startDecline(r))
                            }, "Not doing this", 8, _hoisted_13)
                          ]))
                    ]))
                  }), 128))
                ])
              ], 32)
            ]))
          : (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "task-reminders-pill",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.expand()))
            }, _toDisplayString(_ctx.reminders.length) + " task" + _toDisplayString(_ctx.reminders.length == 1 ? '' : 's') + " waiting for you ", 1))
      ], 64))
    : _createCommentVNode("", true)
}